export function calculateDeliveryDate(now = new Date(), workingDays = 2, timeZone = 'Europe/Bratislava') {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const part = key => Number(parts.find(item => item.type === key).value);
  const date = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
  let remaining = Math.max(1, Math.min(30, Math.floor(Number(workingDays)) || 2));
  while (remaining > 0) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) remaining -= 1;
  }
  return { date, iso: date.toISOString().slice(0, 10) };
}

export function updateDeliveryEstimates(now = new Date()) {
  const locale = document.documentElement.lang || 'sk';
  document.querySelectorAll('[data-business-delivery]').forEach(element => {
    const format = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', ...(element.dataset.dateStyle === 'short' ? {} : { weekday: 'long' }), day: 'numeric', month: 'numeric', year: 'numeric' });
    const result = calculateDeliveryDate(now, element.dataset.workingDays, element.dataset.timeZone);
    const output = element.querySelector('[data-delivery-date]');
    output.dateTime = result.iso;
    output.textContent = format.format(result.date);
    element.querySelector('[data-delivery-estimate]').hidden = false;
  });
}

if (typeof document !== 'undefined') {
  updateDeliveryEstimates();
  window.addEventListener('focus', () => updateDeliveryEstimates());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateDeliveryEstimates(); });
}
